import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router';
import { darken, rem } from 'polished';
import { __ } from 'react-i18n';
import { getProductDetailInfo } from '../../../utilities/selectors';
import { getImagePath } from '../../../utilities/product';
import { Button } from '../General/Button';
import { TextP } from '../../Defaults/Text';

export interface Props {
  items: any;
  handleChooseGift: any;
  theme: any;
  withPrices: boolean;
}

function GiftChooserModalContent(props: Props) {
  const { items, handleChooseGift, withPrices } = props;
  return (
    <Wrapper>
      <StyledTitle>{__('Vyberte si darček')}</StyledTitle>
      <GiftsList>
        {items &&
          items.map(item => {
            const productData = getProductDetailInfo(item);
            const { id, name, image, price, currency, shortDesc } = productData;
            return (
              <GiftItem key={id}>
                {/* tslint:disable-next-line:jsx-no-lambda */}
                <GiftItemLink onClick={() => handleChooseGift(item)}>
                  <GiftItemImg
                    width={160}
                    height={160}
                    src={getImagePath(image, { width: 160, height: 160 })}
                  />
                  <GiftItemName>{name}</GiftItemName>
                  <GiftItemDesc
                    dangerouslySetInnerHTML={{ __html: shortDesc }}
                  />
                  <GiftItemChooseButton>{__('Vybrať')}</GiftItemChooseButton>
                </GiftItemLink>
              </GiftItem>
            );
          })}
      </GiftsList>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: 100%;
`;

const StyledTitle = styled.h3`
  font-size: ${rem(20)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 500;
`;

const GiftsList = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: ${rem(16)};
  overflow-y: auto;
  height: 90%;
  padding: ${rem(16)} ${rem(2)};
`;

const GiftItem = styled.div`
  height: fit-content;
  box-shadow: 0px 2px 6px rgb(0 0 0 / 16%);
  padding: ${rem(24)};
  border-radius: ${rem(4)};
  width: 48%;

  ${({ theme }) => theme.mediab.l925`
    width: 48%;
  `}
  ${({ theme }) => theme.mediab.m580`
    width: 100%;
  `}
`;

const GiftItemLink = styled.button`
  cursor: pointer;
  width: 100%;
  padding: 0;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.textPrimary};
  transition: color 0.2s;
  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }
`;

const GiftItemImg = styled.img`
  width: ${rem(160)};
  height: auto;
  margin-bottom: ${rem(16)};
`;

const GiftItemName = styled(TextP)`
  font-size: ${rem(16)};
  margin-bottom: ${rem(12)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: center;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-family: ${({ theme }) => theme.font.tertiary};
`;

const GiftItemDesc = styled.div`
  text-align: left;
  color: rgb(170, 170, 170);
  font-size: 0.875rem;
  display: -webkit-box;
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: text;
  height: ${rem(56)};
  vertical-align: middle;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

const GiftItemChooseButton = styled(Button)`
  font-size: ${rem(16)};
  margin-top: ${rem(8)};
  margin-right: 0;
  text-align: center;
  font-weight: 500;
  width: 100%;
`;

const WithThemeRow: any = withTheme(GiftChooserModalContent);
export { WithThemeRow as DsiGiftChooserModalContent };
